/**
 * SKU数据加载Hook
 * 职责: 管理SKU和品牌数据的加载
 * 限制: <60行
 */

import { useState, useCallback } from 'react';
import { App } from 'antd';
import { skuAPI } from '../../../services/api';
import * as brandService from '../../../services/brandService';
import type { SKU } from '../../../types';

export const useSKUData = () => {
  const { message } = App.useApp();
  const [skus, setSkus] = useState<SKU[]>([]);
  const [brands, setBrands] = useState<brandService.BrandSimple[]>([]);
  const [loading, setLoading] = useState(false);

  /**
   * 加载SKU列表
   */
  const loadSKUs = useCallback(async () => {
    setLoading(true);
    try {
      const response = await skuAPI.list();
      const data = response.data;
      if (Array.isArray(data)) {
        setSkus(data);
      } else if (data && typeof data === 'object' && 'results' in data) {
        setSkus((data as any).results || []);
      } else {
        setSkus([]);
      }
    } catch (error: any) {
      message.error('加载SKU列表失败');
    } finally {
      setLoading(false);
    }
  }, [message]);

  /**
   * 加载品牌列表
   */
  const loadBrands = useCallback(async () => {
    try {
      const data = await brandService.getSimpleBrands(true);
      setBrands(data);
    } catch (error) {
      console.error('加载品牌列表失败:', error);
    }
  }, []);

  return {
    skus,
    brands,
    loading,
    loadSKUs,
    loadBrands,
  };
};

